import { Component, Input, OnInit} from '@angular/core';
import {DocumentoPac} from 'src/app/model/DocumentoPac';

@Component({
  selector: 'app-informacoes-gerais-operacao',
  templateUrl: './informacoes-gerais-operacao.component.html',
  styleUrls: ['./informacoes-gerais-operacao.component.scss'],
  standalone: false
})
export class InformacoesGeraisOperacaoComponent implements OnInit {

  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  constructor() { }

  ngOnInit(): void {
  }

  public  get valorProximosPls () {
    return (this.documentoPac?.valorFinanciadoFname - (this.documentoPac?.valorInstituicaoCredenciada + this.documentoPac?.valorParticipacaoFinaciado));
  }

  get numeroPacToString(): string{
    return  String(this.documentoPac.numeroPac || '000000').padStart(6, '0');
  }
}
